type FitHeightInput = {
  /** Height of the visible area the page scrolls in */
  viewportHeight: number;
  /** Distance from the top of the scrolled content to the top of the table wrapper */
  top: number;
  /** Space below the table wrapper: the row counter and the ancestors' padding, border and margin */
  bottomInset: number;
  /** Natural height of the table plus the wrapper's border and scrollbar, so a short table does not leave empty space */
  contentHeight: number;
  /** Lowest height the wrapper gets on a small screen; the page scrolls instead */
  minHeight: number;
};

/**
 * Height in whole pixels for a table wrapper that should end at the bottom of the viewport.
 *
 * None of the inputs depend on the wrapper's own height, so writing the result back
 * and measuring again gives the same value. The one exception, a scrollbar that appears once
 * the wrapper is capped, changes contentHeight only when the cap is already below it. Rounding down keeps a fractional remainder from
 * making the page scroll by a pixel.
 */
export const computeFitHeight = ({
  viewportHeight,
  top,
  bottomInset,
  contentHeight,
  minHeight,
}: FitHeightInput): number => {
  const available = viewportHeight - top - bottomInset;

  return Math.floor(Math.min(contentHeight, Math.max(available, minHeight)));
};
